<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد تجمیعی </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 mt-2 py-1">

    <!-- <div class="row ">

        <div class=" col-md-6 ">

            <label> نام مدرسه </label>

            <input type="search" class="form-control" autocomplete="off" [(ngModel)]="searchText"

                (input)="filterItems()" />

        </div>

        <div class="row ">

            <div class="col-md-6">

                <ul class="list-group" style="max-height: 200px;overflow: auto;">

                    <li class="list-group-item pointer" *ngFor="let item of filteredItems" [@fadeAnimation]

                        (click)="onSchool_change(item)">{{ item.strComment }}</li>

                </ul>

            </div>

        </div>


    </div> -->

    <div class="row gx-2 gy-2 w-100 mt-2 ">

        <div id="chart1" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد شکایات به تفکیک مدرسه </p>

                <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart2" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد دانش آموز به تفکیک مدرسه </p>

                <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart3" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد راننده به تفکیک مدرسه </p>

                <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart11" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="col-12">

                <p class="text-center f18 dirI"> تعداد خودرو به تفکیک نوع </p>

                <canvas id="myChart4" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart12" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد خودرو براساس سال ساخت</p>

                <canvas id="myChart5" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart12" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> رانندگان پر خطر </p>

                <canvas id="myChart6" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart13" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> پر تخلف ترین رانندگان </p>

                <canvas id="myChart7" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div class="p-2 border border-2 rounded shadow" style="height: 600px;">

            <p class="text-center f18 "> پراکندگی مدارس </p>

            <div id="map1" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>

        <div class="p-2 border border-2 rounded shadow" style="height: 600px;">

            <p class="text-center f18 "> وضعیت پراکندگی تخلفات </p>

            <div id="test2" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>


    </div>

    <p class="sticky-top fw-bold text-center bg-blue-light py-2 mt-2" style="top:5.5%">

        نمودار درختی آمار خودروها به صورت کلی

    </p>
    
    <div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>


    <p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">

        نمودار درختی متوسط عمر خودروها (سال)
    
    </p>
    
    <div echarts [autoResize]="true" [options]="options3 | async" id="vehicleLife" class="tree-chart"></div>

</div>


<div class="modal fade dirI" id="carCluster" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="clusterModal">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{clusterModal.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap">
                <div class="col-5" *ngIf="clusterModal.strDate">
                    <p class="text-secondary dirI"> <span class="bold">آخرین زمان موقعیت</span> :
                        {{clusterModal.strDate}}-{{clusterModal.strTime}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobile">
                    <p class="text-secondary"> <span class="bold">موبایل</span> : {{clusterModal.strMobile}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobileType_strComment">
                    <p class="text-secondary"> <span class="bold">گروه خودرو</span> :
                        {{clusterModal.strMobileType_strComment}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strVehicleNo">
                    <p class="text-secondary"><span class="bold">پلاک</span> : {{clusterModal.strVehicleNo}}</p>
                </div>
                <div class="col-5 " *ngIf="clusterModal.strJournalType_strComment">
                    <p class="text-secondary"><span class="bold">تخلف</span> :
                        {{clusterModal.strJournalType_strComment}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.tiMaxSpeed">
                    <p class="text-secondary"><span class="bold">حداکثر سرعت مجاز</span> : {{clusterModal.tiMaxSpeed}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strComment">
                    <p class="text-secondary"><span class="bold">توضیحات</span> : {{clusterModal.strComment}}</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
            </div>
        </div>
    </div>
</div>